module.exports = __webpack_public_path__ + "6c008941d59473a491020ba7c737dc39.png";